import { setHost, setAdminHost, View } from '@esoptra/zaza-sdk';
import { FileInfo } from '@esoptra/zaza-sdk/lib/types/lib/files';
import { View as viewContext } from '@twintag/twintag-core';
import { PRODUCTIONFLAG, ADMINHOST, HOST } from './settings';

class apiHelper {
    folders: FileInfo[] | undefined;
    view: View | undefined;
    host = window.origin;
    private static _instance: apiHelper;

    public static get Instance() {
        // Do you need arguments? Make it a regular static method instead.
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.setDefaults();
    }

    async setDefaults() {
        if (!PRODUCTIONFLAG) {
            this.host = HOST;
            setHost(HOST);
            setAdminHost(ADMINHOST);
        }
        if (!this.view) {
            this.view = new View(viewContext.getId());
        }
        if (!this.folders || this.folders.length === 0) {
            this.folders = await this.view.list();
        }
    }

    async GetEpsilonExecutionUrl(fileName: string, host: string) {
        const virtualFile: any = this.folders?.filter((result: any) => {
            return result.Name === fileName;
        });
        if (virtualFile && virtualFile[0])
            return (
                host +
                '/api/v1/views/' +
                virtualFile[0].TemplateBagId +
                '/files/' +
                virtualFile[0].FileQid
            );
        return '';
    }

    public async ExecuteEpsilon(body: any) {
        await this.setDefaults();
        const resp = await this.ExecuteEpsilonPOST('api', body, this.host);
        return resp;
    }

    async ExecuteEpsilonPOST(fileName: string, body = {}, host: string) {
        const url = await this.GetEpsilonExecutionUrl(fileName, host);
        const data = await this.view?.data();
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + data?.authToken);
        headers.append('Content-Type', 'application/json');

        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify(body),
        };

        const response = await fetch(url, requestOptions);
        const result = await response.text();
        if (response.status !== 200) {
            return '';
        }
        if (result) return JSON.parse(result);
    }
}

export default apiHelper.Instance;
